export default __webpack_public_path__ + "static/media/01__o_1.ccdb2b4e.jpg";